import { render, staticRenderFns } from "./CreateResourceForLanguage.vue?vue&type=template&id=1bcf65d1"
import script from "./CreateResourceForLanguage.vue?vue&type=script&lang=js"
export * from "./CreateResourceForLanguage.vue?vue&type=script&lang=js"
import style0 from "./CreateResourceForLanguage.vue?vue&type=style&index=0&id=1bcf65d1&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports